var _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWshare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.65625 13.109375 L 3.65625 -52.3125 L 40.390625 -52.3125 L 40.390625 13.109375 Z M 7.78125 8.984375 L 36.296875 8.984375 L 36.296875 -48.15625 L 7.78125 -48.15625 Z M 7.78125 8.984375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 44.015625 -52.390625 L 44.015625 -40.9375 C 41.078125 -42.269531 38.207031 -43.273438 35.40625 -43.953125 C 32.601562 -44.628906 29.960938 -44.96875 27.484375 -44.96875 C 24.179688 -44.96875 21.738281 -44.503906 20.15625 -43.578125 C 18.582031 -42.660156 17.796875 -41.238281 17.796875 -39.3125 C 17.796875 -37.863281 18.328125 -36.734375 19.390625 -35.921875 C 20.453125 -35.109375 22.382812 -34.414062 25.1875 -33.84375 L 31.0625 -32.640625 C 37.019531 -31.429688 41.253906 -29.59375 43.765625 -27.125 C 46.273438 -24.664062 47.53125 -21.164062 47.53125 -16.625 C 47.53125 -10.664062 45.773438 -6.226562 42.265625 -3.3125 C 38.765625 -0.40625 33.414062 1.046875 26.21875 1.046875 C 22.820312 1.046875 19.414062 0.71875 16 0.0625 C 12.582031 -0.582031 9.160156 -1.546875 5.734375 -2.828125 L 5.734375 -14.59375 C 9.160156 -12.757812 12.46875 -11.378906 15.65625 -10.453125 C 18.851562 -9.523438 21.929688 -9.0625 24.890625 -9.0625 C 27.910156 -9.0625 30.21875 -9.566406 31.8125 -10.578125 C 33.414062 -11.585938 34.21875 -13.035156 34.21875 -14.921875 C 34.21875 -16.617188 33.671875 -17.925781 32.578125 -18.84375 C 31.492188 -19.757812 29.328125 -20.578125 26.078125 -21.296875 L 20.734375 -22.5 C 15.378906 -23.65625 11.460938 -25.5 8.984375 -28.03125 C 6.503906 -30.570312 5.265625 -33.992188 5.265625 -38.296875 C 5.265625 -43.679688 6.988281 -47.820312 10.4375 -50.71875 C 13.882812 -53.625 18.835938 -55.078125 25.296875 -55.078125 C 28.234375 -55.078125 31.253906 -54.851562 34.359375 -54.40625 C 37.472656 -53.957031 40.691406 -53.285156 44.015625 -52.390625 Z M 44.015625 -52.390625 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 43.98,
    y1: 460.8,
    x2: 912.89,
    y2: 460.8,
    gradientTransform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(90.980392%,85.490196%,92.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(81.960784%,84.705882%,89.411765%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 70.976562 36.183594 C 70.976562 55.023438 55.859375 70.296875 37.207031 70.296875 C 18.554688 70.296875 3.433594 55.023438 3.433594 36.183594 C 3.433594 17.34375 18.554688 2.070312 37.207031 2.070312 C 55.859375 2.070312 70.976562 17.34375 70.976562 36.183594 Z M 70.976562 36.183594 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(20%,28.235294%,46.27451%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 14.34375,
    y: 60.934165
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 22.25,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(28.235294%,31.764706%,40%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 912.870285 460.808117 C 912.870285 700.738761 718.402436 895.25023 478.458255 895.25023 C 238.514074 895.25023 43.995974 700.738761 43.995974 460.808117 C 43.995974 220.877474 238.514074 26.366005 478.458255 26.366005 C 718.402436 26.366005 912.870285 220.877474 912.870285 460.808117 Z M 912.870285 460.808117 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20%,28.235294%,46.27451%)",
      fillOpacity: 1
    },
    d: "M 31.453125 49.417969 L 38.964844 47.628906 L 33.679688 39.941406 L 33.597656 33.953125 L 35.039062 31.203125 L 37.964844 31.203125 L 40.566406 29.179688 L 45.292969 29.179688 L 53.066406 32.738281 L 59.101562 37.9375 L 61.945312 44.714844 L 60.675781 54.34375 L 54.828125 59.847656 L 49.058594 63.730469 L 44.332031 64.539062 L 38.40625 63.8125 L 31.996094 60.089844 L 27.191406 54.425781 L 25.507812 49.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.647059%,75.686275%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 33.410156 41.957031 L 36.636719 41.074219 L 39.683594 42.394531 L 43.214844 42.394531 L 46.808594 40.039062 L 50.035156 42.683594 L 51.070312 46.539062 L 51.070312 51.082031 L 53.6875 46.136719 L 53.019531 40.730469 L 56.183594 44.699219 L 56.671875 47.6875 L 55.148438 53.960938 L 58.679688 49.355469 L 58.679688 42.914062 L 56.976562 37.5625 L 53.808594 33.996094 L 48.886719 32.253906 L 44.222656 29.625 L 40.046875 30.777344 L 38.160156 31.984375 L 36.453125 31.925781 L 34.75 32.960938 L 34.078125 34.574219 L 32.496094 36.300781 L 31.765625 38.65625 L 32.132812 40.210938 Z M 33.410156 41.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.705882%,33.72549%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 30.964844 38.605469 L 31.644531 36.542969 L 33.847656 33.992188 L 35.289062 34.195312 L 37.054688 32.253906 L 41.617188 33.304688 L 43.726562 35.429688 L 44.542969 36.90625 L 44.542969 40.910156 L 40.21875 38.890625 L 38.292969 37.835938 L 35.769531 38.523438 L 34.347656 40.910156 L 33.25 42.449219 L 31.644531 40.628906 Z M 30.964844 38.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(24.705882%,33.72549%,53.333333%)",
      fillOpacity: 1,
      strokeWidth: 2.19,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(72.54902%,89.411765%,98.039216%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 547.049628 403.549115 L 556.345895 390.664595 L 572.827924 390.664595 L 590.314956 407.180659 L 590.314956 428.820681 L 580.063937 441.655454 L 554.285641 428.273462 Z M 547.049628 403.549115 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,27.058824%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 42.539062 31.6875 L 44.542969 32.304688 L 43.101562 33.628906 Z M 42.539062 31.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,27.058824%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 44.542969 32.304688 L 45.105469 34.679688 L 45.902344 33.671875 Z M 44.542969 32.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(42.745098%,59.215686%,74.509804%)",
      fillOpacity: 1
    },
    d: "M 44.542969 32.304688 L 44.542969 30.675781 L 45.902344 31.972656 Z M 44.542969 32.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.980392%,13.72549%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 31.765625 40.765625 L 32.636719 38.734375 L 34.691406 38.300781 L 35.769531 38.523438 L 33.707031 42.734375 L 32.722656 41.855469 Z M 31.765625 40.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.980392%,13.72549%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 38.292969 37.835938 L 42.28125 37.835938 L 44.542969 40.910156 L 41.679688 39.578125 L 40.082031 38.816406 Z M 38.292969 37.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 34.070312 41.558594 L 37.074219 39.375 L 39.683594 42.394531 L 36.582031 41.367188 Z M 34.070312 41.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 43.214844 42.394531 L 46.996094 38.523438 L 50.035156 42.683594 L 46.808594 40.039062 Z M 43.214844 42.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 51.070312 51.082031 L 52.253906 46.332031 L 50.035156 42.683594 L 51.070312 46.539062 Z M 51.070312 51.082031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 55.148438 53.960938 L 56.671875 47.6875 L 56.183594 44.699219 L 57.660156 48.113281 Z M 55.148438 53.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(24.705882%,33.72549%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 25.507812 49.085938 L 30.964844 52.363281 L 27.191406 54.425781 L 33.269531 56.210938 L 31.996094 60.089844 L 43.238281 59.644531 L 47.207031 61.898438 L 52.253906 60.007812 L 60.675781 54.34375 L 54.484375 60.535156 L 49.058594 63.730469 L 43.726562 64.863281 L 38.40625 63.8125 L 33.136719 60.75 L 32.070312 60.128906 L 31.890625 59.964844 L 27.324219 54.582031 L 27.128906 54.226562 Z M 25.507812 49.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.54902%,89.411765%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 32.636719 40.144531 L 33.707031 38.707031 L 35.222656 38.769531 L 35.039062 45 L 36.023438 50.84375 L 38.855469 57.261719 L 40.363281 59.929688 L 40.679688 61.898438 L 38.917969 61.011719 L 36.777344 58.085938 L 33.882812 51.414062 L 32.816406 44.804688 Z M 32.636719 40.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 33.707031 38.707031 L 35.039062 45 L 35.222656 38.769531 Z M 33.707031 38.707031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 33.882812 51.414062 L 37.964844 57.5 L 38.917969 61.011719 L 36.777344 58.085938 Z M 33.882812 51.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 40.679688 61.898438 L 39.125 59.605469 L 40.363281 59.929688 Z M 40.679688 61.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.54902%,89.411765%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 39.984375 38.300781 L 41.789062 38.371094 L 43.238281 39.664062 L 43.117188 43.632812 L 44.105469 49.476562 L 46.933594 55.894531 L 48.445312 58.5625 L 48.757812 60.535156 L 46.996094 59.644531 L 44.859375 56.722656 L 41.964844 50.046875 L 40.894531 43.441406 Z M 39.984375 38.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 41.789062 38.371094 L 43.171875 41.914062 L 43.238281 39.664062 Z M 41.789062 38.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 41.964844 50.046875 L 46.046875 56.132812 L 46.996094 59.644531 L 44.859375 56.722656 Z M 41.964844 50.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 48.757812 60.535156 L 47.207031 58.238281 L 48.445312 58.5625 Z M 48.757812 60.535156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2.19,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(80.784314%,92.156863%,98.431373%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 547.049628 403.549115 L 556.345895 390.664595 L 572.827924 390.664595 L 590.314956 407.180659 L 590.314956 428.820681 L 580.063937 441.655454 L 554.285641 428.273462 Z M 547.049628 403.549115 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 47.195312 38.300781 L 51.789062 42.449219 L 52.75 46.425781 L 50.980469 42.449219 Z M 47.195312 38.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.843137%,62.352941%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 53.742188 40.605469 L 57.015625 44.269531 L 58.160156 48.183594 L 57.40625 43.964844 Z M 53.742188 40.605469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(78.039216%,81.960784%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 50.316406 33.253906 L 53.59375 34.347656 L 56.566406 37.6875 L 53.050781 34.679688 Z M 50.316406 33.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 32.816406 44.804688 L 36.023438 50.84375 L 33.882812 51.414062 Z M 32.816406 44.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.627451%,95.686275%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 41.964844 50.046875 L 44.105469 49.476562 L 40.378906 40.515625 Z M 41.964844 50.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 44.105469 49.476562 L 46.046875 56.132812 L 46.933594 55.894531 Z M 44.105469 49.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 36.023438 50.84375 L 37.964844 57.5 L 38.855469 57.261719 Z M 36.023438 50.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 32.785156 43.988281 L 33.210938 39.375 L 32.636719 40.144531 Z M 32.785156 43.988281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.823529%,72.941176%,80%)",
      fillOpacity: 1
    },
    d: "M 39.984375 38.300781 L 41.789062 41.15625 L 41.605469 43.46875 L 40.378906 40.515625 Z M 39.984375 38.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(24.705882%,33.72549%,53.333333%)",
      fillOpacity: 1,
      strokeWidth: 2.49,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(72.54902%,89.411765%,98.039216%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 485.342517 220.827727 L 435.393927 220.827727 L 410.419633 264.058025 L 435.393927 307.288324 L 485.342517 307.288324 L 510.316812 264.058025 Z M 485.342517 220.827727 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(42.745098%,59.215686%,74.509804%)",
      fillOpacity: 1
    },
    d: "M 37.742188 17.339844 L 35.800781 20.734375 L 39.683594 20.734375 Z M 37.742188 17.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,27.058824%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 33.859375 24.128906 L 35.800781 20.734375 L 37.742188 24.128906 Z M 33.859375 24.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,27.058824%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 31.917969 20.734375 L 35.800781 20.734375 L 33.859375 17.339844 Z M 31.917969 20.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 4.22,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(72.54902%,89.411765%,98.039216%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 485.342517 220.827727 L 435.393927 220.827727 L 410.419633 264.058025 L 435.393927 307.288324 L 485.342517 307.288324 L 510.316812 264.058025 Z M 485.342517 220.827727 ",
    transform: "matrix(0.0777362,0,0,0.078522,0.0135148,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWshare);
export default __webpack_public_path__ + "static/media/wshare.a8a58e48ffafeec26a88a0c23ae05c80.svg";
export { ForwardRef as ReactComponent };